import React from "react";
import {
  View,
  ScrollView,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
} from "react-native";

import integrationStyles from "../integrationStyles";

import steps from "../steps";
import { isWeb, navigate } from "../../../../../helpers/utils";
import ImageComponent from "../../../common/ImageComponent";
import AppTheme from "../../../AppTheme";
import appStyles from "../../../../appStyles";
import appPages from "../../../../../appPages";
import CarouselProgressBar from "../../../animation/progressBar/CarouselProgressBar";
import ProgressBarConfig from "../../../animation/progressBar/config";
import ManaButton from "../../../common/ManaButton";

export default function DesktopIntegrationDownloadStarted({
  controller,
  goToStep = () => {},
  isFromCard = false,
}) {
  const buttonText = isFromCard ? "Finish" : "Continue";
  const currentScreenIndex = ProgressBarConfig["integrationsDesktop"];
  const numberOfScreens = Object.keys(ProgressBarConfig).length;

  const onButtonPress = () => {
    if (isFromCard) {
      navigate(controller, appPages.integrationsV2);
    } else {
      goToStep(isWeb ? steps.checklist : steps.health);
    }
  };

  return (
    <>
      <CarouselProgressBar
        currentScreenIndex={currentScreenIndex}
        numberOfScreens={numberOfScreens}
        changeScreen={() => goToStep(steps.desktop)}
        hideNext
      />

      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <Text style={integrationStyles.header}>Super!</Text>
        <Text style={styles.sectionText}>
          {isWeb
            ? "Desktop sync is downloading now"
            : "Please follow the download instructions in the email you received"}
          .
        </Text>

        <View
          style={{
            alignItems: "center",
            marginTop: 60,
            marginBottom: 35,
          }}
        >
          <ImageComponent
            image={require("../../../../../assets/integrations/desktopBig.png")}
            style={styles.desktopIcon}
          />
        </View>

        <Text style={styles.sectionText}>
          Please install as soon as possible for the best experience!
        </Text>
      </ScrollView>

      <View style={[appStyles.footerButtons]}>
        <ManaButton
          isMainButton
          onPress={onButtonPress}
          style={appStyles.bottomButton}
          textStyle={appStyles.bottomButtonText}
          text={buttonText}
        />
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  sectionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    marginTop: 32,
    textAlign: "center",
  },
  desktopIcon: {
    width: 279,
    height: 266,
  },
});
